<router-outlet></router-outlet>

<!-- ส่วนของการแสดง Loading page -->
@if (isLoadingPage) {
  <app-loading (onTimeout)="onLoadingTimeout()"></app-loading>
}

<!-- ส่วนของการแสดง Notify แบบ Toast -->
<p-toast key="notify" styleClass="base-toast" position="top-center">
  <ng-template let-item pTemplate="message">
    <div class="p-toast-message-text">
      <span class="material-symbols-outlined">{{ item.icon }}</span>
      <div class="p-toast-summary">{{ item.summary }}</div>
    </div>
  </ng-template>
</p-toast>

<!-- ส่วนของการแสดล Notify แบบ Alert -->
<p-confirmdialog [closable]="false" styleClass="base-confirm-dialog" key="dialog-confirm"></p-confirmdialog>